import { createContext, useContext } from 'react'
import type { ToastType, ToastAction } from '../components/Toast'

export interface ShowToastOptions {
  /** Auto-dismiss delay in ms. Pass 0 to disable auto-dismiss. Defaults to 3000. */
  duration?: number
  /** Optional inline action button. */
  action?: ToastAction
}

interface ToastContextType {
  showToast: (message: string, type: ToastType, options?: ShowToastOptions) => void
}

export const ToastContext = createContext<ToastContextType | undefined>(undefined)

export function useToast() {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToast must be used within ToastProvider')
  }
  return context
}
